// To fix webengage null and undefined issue
const getSafePayloadObject = obj => {
  const safeObject = {};

  Object.keys(obj).forEach(key => {
    if (obj[key] !== null && obj[key] !== undefined && typeof obj[key] !== 'function') {
      safeObject[key] = obj[key];
    }
  });

  return safeObject;
};

// To fix webengage eventName issue
const getSafeEventName = eventNameLocal => {
  if (eventNameLocal.startsWith('we_')) {
    return eventNameLocal.slice(0, 2).toUpperCase() + eventNameLocal.slice(2);
  }

  return eventNameLocal;
};

const trackWebengage = (event, payload = {}) => {
  if (event && payload && window.webengage) {
    window.webengage.track(getSafeEventName(event), getSafePayloadObject(payload));
  }
};

export default trackWebengage;
